module.exports = ":host #main-wrapper {\n  padding-bottom: 20px; }\n  :host #main-wrapper .quote-introduction {\n    padding: 10px;\n    line-height: 24px;\n    height: 70px;\n    resize: none; }\n  :host #main-wrapper .fixed-quote-summary-table {\n    border-bottom: 1px solid #dddddd; }\n    :host #main-wrapper .fixed-quote-summary-table td {\n      padding-top: 5px;\n      padding-bottom: 25px; }\n      :host #main-wrapper .fixed-quote-summary-table td:first-child {\n        padding-left: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/quote-update/quote-update.scss
// module id = ./web/modern/components/quotes/quote-update/quote-update.scss
// module chunks = 0